<template>
  <div>
    <!-- editDialog -->
    <v-dialog
      v-model="editDialog"
      persistent 
      max-width="800px"
      transition="dialog-transition"
    >
        <v-flex
          class="xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"
         >
         <v-flex class="xs12  ">

          <h2 v-if="adding == true">Add new Customs</h2>
          <h2 v-if="adding==false">Editing Customs</h2>
        </v-flex>
         <v-flex class="xs12 my-4 ">
            <label for="main_visa_status" class="grey--text">Main visa status</label><br>
            <v-btn-toggle mandatory v-model="editedCustomsHistory.main_visa_status">
              <v-btn small flat value="non-eu"> Non eu </v-btn>
              <v-btn small flat value="eu"> eu </v-btn>
              <v-btn small flat value="freeport">freeport </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-menu
              v-model="menu2"
              :return-value.sync="editedCustomsHistory.import_date"
              ref="menu2"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              landscape
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                v-model="editedCustomsHistory.import_date"
                slot="activator"
                label="Import Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                persistent
                color="black"
                v-model="editedCustomsHistory.import_date"
                @input="$refs.menu2.save(editedCustomsHistory.import_date)"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex class="xs12">
            <v-text-field
              v-model="editedCustomsHistory.import_taxes"
              name="import_taxes"
              label="Import Taxes"
              prepend-icon="euro_symbol"
            ></v-text-field>
          </v-flex>

          <v-flex class="xs12">
            <v-text-field
              v-model="editedCustomsHistory.mover_importer"
              name="mover_importer"
              label="Mover Importer"
            ></v-text-field>
          </v-flex>

          <v-flex class="xs12">
            <v-textarea
              v-model="editedCustomsHistory.import_export_notes"
              name="import_export_notes"
              label="Import Export Notes"
            ></v-textarea>
          </v-flex>

          <v-flex class="xs12"></v-flex>

          <v-flex class="xs12 pr-0 mr-0 mt-3" text-xs-right>
            <v-btn @click="cancelAddDialog" small>cancel</v-btn>
              <!-- :dark="!(editedCustomsHistory.artwork_ownership_id == null || editedCustomsHistory.artwork_ownership_id == '')" -->
            <v-btn
              @click="save_edited_artwork_customs_history" small dark
              >save</v-btn
            >
              <!-- :disabled="true" -->
                <!-- (editedCustomsHistory.artwork_ownership_id == null || editedCustomsHistory.artwork_ownership_id == '')" -->
          </v-flex>
        </v-flex>      
    </v-dialog>

    <v-layout column class="mt-0">

      <v-layout row wrap xs12 sm12 md12 mt-0 ml-0 mr-0 px-0 v-if="c_user.edit">

        <!--v-flex-- 
          text-xs-center ml-2 mr-2
          v-if="
            artwork.artwork_customs_logs &&
              artwork.artwork_customs_logs.length > 0
          "
        >
          Show Customs History
          <v-btn icon small @click="showList = !showList" class="my-0 py-0">
            <v-icon v-if="!showList">expand_more</v-icon>
            <v-icon v-if="showList">expand_less</v-icon>
          </v-btn>
        </!--v-flex-->

      </v-layout>
      
      <!-- && showList -->
      <v-flex row xs12 sm12 md12 mt-0 ml-2 mr-2 v-if="c_user.edit ">
        <v-list
          class="xs12"
          v-if="
            artwork.artwork_customs_logs &&
              artwork.artwork_customs_logs.length > 0
          "
        >
          <!-- <v-flex> -->
            <template v-for="l in artwork.artwork_customs_logs">
              <div class="mx-4 py-2" :key="l.id">
                <div class="">
                    <span class="left" >
                      <span v-if="l.import_date != null" class="font-weight-bold title"
                        >{{ format_date(l.import_date) }}</span
                      >
                    </span>
                    <span class="right" v-if="l.import_taxes != null">
                      Import Taxes:
                      <span  class="text-uppercase font-weight-bold"
                        > {{ l.import_taxes }} EUR
                      </span>
                    </span>
                  
                </div>
                <div>
                  <v-list-tile-title>
                    <div v-if="l.main_visa_status != null">
                      Main Visa Status:
                      <span class="text-uppercase font-weight-bold"> 
                        {{ l.main_visa_status }}
                      </span >
                    </div>
                    <div>
                      <span v-if="l.mover_importer != null"
                        >Mover Importer: {{ l.mover_importer }}</span
                      >
                    </div>
                  </v-list-tile-title>
                  <div v-if="l.import_export_notes" class="caption">
                    <span>{{ l.import_export_notes }}</span>
                  </div>
                </div>
                <v-list-tile-action class="right pr-0 mr-0">
                  <span >
                    <v-btn :key="l.id+'b'" small class="mr-0" icon @click="editCustomsHistory(l)" >
                      <v-icon small color="black">edit</v-icon>
                    </v-btn>
                  </span>
                </v-list-tile-action>
              </div>
              <v-divider class="mt-4" :key="`a${l.id}`"></v-divider>
            </template>
          <!-- </v-flex> -->
        </v-list>
        <v-btn icon small @click="showAddDialog" class="my-0 py-0 ">
          <v-icon >+</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function(a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

import axios from '@/utils/apiClient';
export default {
  name: "CustomsHistory",
  props: ["artwork"],
  data: () => ({
    adding: false,
    editDialog: false,
    editedCustomsHistory: {},
    artwork_ownership_history: {},
    selectedPackings: [],
    menu2: false,
    showUpload: false,
    showList: false,
    show: false,
    errors: "",
    artwork_customs_log: {
      id: "",
      import_export_notes: "",
      import_date: "",
      main_visa_status: "",
      import_taxes: "",
      mover_importer: ""
    }
  }),
  // computed: {  },
  methods: {
    showAddDialog() {
      this.editDialog = true;
      this.adding = true;
    },
    cancelAddDialog() {
      this.editDialog = false;
      this.adding = false;
      this.editedCustomsHistory = {
            id: "",
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };

    },
    editCustomsHistory(l) {
      this.editedCustomsHistory = l
      this.editDialog = true
    },
    save_edited_artwork_customs_history() {
      this.editedCustomsHistory.last_update_by = this.c_user.id;
      this.editedCustomsHistory.artwork_id = this.artwork.id;
      if (this.adding == true) {
        var url = `${this.$globals.apiserver}/artwork_customs_logs.json`;
        axios
        .post(url, {
          artwork_customs_log: this.editedCustomsHistory
        })
        .then(response => {
          this.$emit("getArtwork");
          this.errors = {};
          this.artwork.artwork_customs_logs = [
            ...this.artwork.artwork_customs_logs.filter(element => element.id !== response.data.id), response.data
          ];
          // this.artwork.artwork_ownership_id = this.editedCustomsHistory.artwork_ownership_id;
          // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
          this.editedCustomsHistory = {
            id: "",
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };
          this.editDialog = false
        })
        .catch(error => {
          console.log(error);
        });
      } else {
        var url = `${this.$globals.apiserver}/artwork_customs_logs/${this.editedCustomsHistory.id}.json`;
        axios
        .put(url, {
          artwork_customs_log: this.editedCustomsHistory
        })
        .then(response => {
          this.$emit("getArtwork");
          this.errors = {};
          this.artwork.artwork_customs_logs = [
            ...this.artwork.artwork_customs_logs.filter(element => element.id !== response.data.id), response.data
          ];
          // this.artwork.artwork_ownership_id = this.editedCustomsHistory.artwork_ownership_id;
          // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
          this.editedCustomsHistory = {
            id: "",
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };
          this.editDialog = false
        })
        .catch(error => {
          console.log(error);
        });
      }
      
  
      axios
        .put(url, {
          artwork_customs_log: this.editedCustomsHistory
        })
        .then(response => {
          this.$emit("getArtwork");
          this.errors = {};
          this.artwork.artwork_customs_logs = [
            ...this.artwork.artwork_customs_logs.filter(element => element.id !== response.data.id), response.data
          ];
          // this.artwork.artwork_ownership_id = this.editedCustomsHistory.artwork_ownership_id;
          // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
          this.editedCustomsHistory = {
            id: "",
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };
          this.editDialog = false
        })
        .catch(error => {
          // console.log(error);
        });
      // var aartwork_ownership_history = Object.keys(this.artwork_ownership_history).forEach(k => this.artwork_ownership_history[k]='')
      // console.log(aartwork_ownership_history)
    },
    delete_log() {},
    save_artwork_customs_log() {
      this.artwork_customs_log.created_by = this.c_user.id;
      this.artwork_customs_log.artwork_id = this.artwork.id;
      if (this.artwork_customs_log.storage == "in") {
        this.artwork_customs_log.storage_in = this.artwork_customs_log.import_date;
      } else {
        this.artwork_customs_log.storage_out = this.artwork_customs_log.import_date;
      }
      // this.artwork_customs_log.id = this.findMinMax(this.all_artwork_customs_logs)+1
      if (!this.artwork.artwork_customs_logs) {
        this.artwork.artwork_customs_logs = [];
      }
      // this.$store.commit('ADD_TODO', this.artwork_customs_log)
      // this.all_artwork_customs_logs.push(this.artwork_customs_log)
      if (
        this.artwork_customs_log.copy == "packings" &&
        this.selectedPackings && this.selectedPackings.length > 0
      ) {
        // console.log('packings')
        for (const sp in this.selectedPackings) {
          // console.log(this.selectedPackings[sp].id)
          this.artwork_customs_log.artwork_packing_id = this.selectedPackings[sp].id;
          // console.log(this.artwork_customs_log);
          axios
            .post(`${this.$globals.apiserver}/artwork_customs_logs.json`, {
              artwork_customs_log: this.artwork_customs_log
            })
            .then(response => {
              this.errors = {};
              // this.artwork.artwork_customs_logs.push(response.data);
              // this.$store.commit("ADD_LOG", response.data);
              this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
              this.showUpload = !this.showUpload;
            })
            .catch(error => {
              // console.log(error);
              // this.errors = error.response.data;
            });
        }
        this.artwork_customs_log = {
          import_export_notes: "",
          import_date: "",
          main_visa_status: "",
          import_taxes: "",
          mover_importer: ""
        };
      } else {
        // console.log('single')
        axios
          .post(`${this.$globals.apiserver}/artwork_customs_logs.json`, {
            artwork_customs_log: this.artwork_customs_log
          })
          .then(response => {
            this.errors = {};
            this.artwork.artwork_customs_logs.push(response.data);
            // this.$store.commit("ADD_LOG", response.data);
            // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
            this.showUpload = !this.showUpload;
            this.artwork_customs_log = {
              import_export_notes: "",
              import_date: "",
              main_visa_status: "",
              import_taxes: "",
              mover_importer: ""
            };
          })
          .catch(error => {
            // console.log(error);
          });
      }

      // var aartwork_customs_log = Object.keys(this.artwork_customs_log).forEach(k => this.artwork_customs_log[k]='')
      // console.log(aartwork_customs_log)
    }
  }
};
</script>

<style scoped>
/* .activeToggle { background-color: gold; color:hotpink; } */
</style>



// WEBPACK FOOTER //
// src/components/artworks/CustomsHistory.vue